export interface AtlasCollection {
  id: string
  name: string
  emoji: string
  description: string
  placeIds: string[]
}

export interface MiniExpedition {
  id: string
  title: string
  emoji: string
  story: string
  placeIds: string[]
}

export const ATLAS_COLLECTIONS: AtlasCollection[] = [
  { id: 'great-buildings', name: 'Great Buildings', emoji: '🏛️', description: 'Marvel at places people built to last.', placeIds: ['forbidden-city', 'pyramids-of-giza', 'taj-mahal', 'colosseum', 'sydney-opera-house', 'blue-mosque'] },
  { id: 'wild-landscapes', name: 'Wild Landscapes', emoji: '🌋', description: 'Collect Earth’s big, bold outdoor views.', placeIds: ['grand-canyon', 'victoria-falls', 'mount-fuji', 'pulpit-rock', 'lake-bled', 'great-barrier-reef'] },
  { id: 'foods-world', name: 'Foods of the World', emoji: '🍜', description: 'Visit food-loving cities around the globe.', placeIds: ['rome', 'tokyo', 'mexico-city', 'paris', 'istanbul', 'beijing'] },
  { id: 'night-lights', name: 'Night Lights', emoji: '✨', description: 'Find places that sparkle after sunset.', placeIds: ['tokyo-tower', 'eiffel-tower', 'burj-khalifa', 'new-york-city', 'hong-kong', 'northern-lights'] },
]

export const MINI_EXPEDITIONS: MiniExpedition[] = [
  { id: 'silk-road', title: 'Follow the Silk Road', emoji: '🐫', story: 'Travel from ancient Beijing to Samarkand and Istanbul, following routes that carried ideas, art, and inventions.', placeIds: ['forbidden-city', 'registan-samarkand', 'blue-mosque'] },
  { id: 'volcano-trail', title: 'Three Volcanoes', emoji: '🌋', story: 'See how fiery mountains shape islands, forests, and whole cities.', placeIds: ['mount-fuji', 'mount-vesuvius', 'mount-bromo'] },
  { id: 'mediterranean-day', title: 'A Mediterranean Day', emoji: '⛵', story: 'Hop from the ancient streets of Rome to Greece and Egypt, all beside one remarkable sea.', placeIds: ['colosseum', 'acropolis-of-athens', 'pyramids-of-giza'] },
]
